import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const A = styled(Link)`
	text-decoration: none;

	:visited {
		color: inherit;
	}
}`